import React, { useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff, Check, X } from "lucide-react";
import { useI18n } from "../context/LanguageContext";

export const passwordValid = (pw = "") =>
    pw.length >= 8 && /[A-Z]/.test(pw) && /[a-z]/.test(pw) && /\d/.test(pw);

export const PasswordInput = ({ className = "", testId, ...props }) => {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <Input {...props} type={show ? "text" : "password"} data-testid={testId}
                className={`pr-10 ${className}`} />
            <button type="button" tabIndex={-1} onClick={() => setShow((s) => !s)}
                data-testid={testId ? `${testId}-toggle` : "password-toggle"}
                aria-label="toggle password visibility"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-200">
                {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
        </div>
    );
};

export const PasswordChecklist = ({ password = "" }) => {
    const { t } = useI18n();
    const items = [
        { ok: password.length >= 8, label: t("pw_rule_len") },
        { ok: /[A-Z]/.test(password), label: t("pw_rule_upper") },
        { ok: /[a-z]/.test(password), label: t("pw_rule_lower") },
        { ok: /\d/.test(password), label: t("pw_rule_digit") },
    ];
    return (
        <div data-testid="pw-requirements" className="rounded-md border border-[#1e293b] bg-[#0b0f17] p-3">
            <div className="text-xs text-slate-400 mb-1.5">{t("pw_requirements")}</div>
            <ul className="space-y-1">
                {items.map((it, i) => (
                    <li key={i} className={`flex items-center gap-1.5 text-xs transition-colors ${it.ok ? "text-emerald-400" : "text-slate-500"}`}>
                        {it.ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />} {it.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};
